import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { ImagePart } from '@/components/PagesSections/FreshdeskIntegration/AiForFreshdesk/ImagePart';
import { TabsComponent } from '@/components/PagesSections/FreshdeskIntegration/AiForFreshdesk/TabsComponent';
import { useInView } from 'framer-motion';
import { clsx } from 'clsx';

type Props = {
  className?: string;
  tab: {
    mainTitle: ReactElement;
    tabsContent: {
      id: number;
      title: string;
      description: string;
      img: string;
      mobileImg: string;
    }[];
  };
};

const delay = 5000;

export const TabsPart = ({ tab, className = '' }: Props) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const interval = useRef<any>(null);
  const ref = useRef(null);
  const isInView = useInView(ref, { margin: '-300px' });

  useEffect(() => {
    if (isInView) {
      interval.current = setInterval(() => {
        setSelectedTab((prevIndex) =>
          prevIndex === tab.tabsContent.length - 1 ? 0 : prevIndex + 1
        );
      }, delay);
    } else {
      clearInterval(interval.current);
    }

    return () => clearInterval(interval.current);
  }, [isInView, tab.tabsContent.length, delay]);

  const handleSelectTab = (id: number) => {
    setSelectedTab(id);
    clearInterval(interval.current);
  };
  return (
    <div
      ref={ref}
      className={clsx(
        className,
        'relative md:rounded-md-10-vw rounded-md-10 overflow-hidden w-full'
      )}
    >
      <div className="flex max-lg:flex-col justify-between items-center lg:gap-0 gap-3.5 lg:pl-24.5-vw max-lg:px-5 max-lg:pt-6">
        {tab.mainTitle}
        <div className="lg:w-7/12 w-full flex justify-center">
          <ImagePart tabsContent={tab.tabsContent} selectedTab={selectedTab} />
        </div>
      </div>
      <TabsComponent
        selectedTab={selectedTab}
        tabsContent={tab.tabsContent}
        handleSelectTab={handleSelectTab}
      />
    </div>
  );
};
